import _                   from 'lodash'
import React               from 'react'
import { Row, Col, Alert } from 'react-bootstrap'
import { BadRequestError } from 'lib/errors'
import Pagination          from './pagination'

# requirements:
# - attributes - relation, tableComponent, formComponent
export default class AdminPage extends React.Component
  # override these
  relation:             -> throw 'all subclasses of AdminPage must override relation()'
  tableComponent:       'all subclasses of AdminPage must override tableComponent'
  formComponent:        'all subclasses of AdminPage must override formComponent'
  additionalRender:     ->
  additionalTableProps: -> {}

  constructor: (props, context) ->
    super(props, context)

    @_tableComponent = null
    @state =
      records: @_relation().emptyCollection()
      page: 1
      pageSize: 20
      showForm: false
      formAction: null
      editedRecordID: null
      errors:     null
      formErrors: {}

  loadRecords: =>
    if @_tableComponent
      ordering = @_tableComponent.getOrdering()
      filters  = @_tableComponent.getFilters()
    else
      ordering = @tableComponent.defaultOrdering ? @_relation().model.primaryKey
      filters  = {}

    @_relation()
      .orderBy(ordering)
      .page(@state.page, @state.pageSize)
      .where(filters)
      .then (records) => @setState({ records })

  componentWillMount: ->
    @loadRecords()

  changePage: (pageNumber) =>
    @setState(page: pageNumber, @loadRecords, errors: null)

  showCreateForm: =>
    @setState(showForm: true,  formAction: 'create', errors: null)

  showUpdateForm: (pk) =>
    @setState(showForm: true,  formAction: 'update', editedRecordID: pk, errors: null)

  hideForm: =>
    @setState(showForm: false, formAction: null,     editedRecordID: null, formErrors: {})

  create: (params) =>
    @_withCreateUpdateHandling(@_relation().create(params), 'create')

  update: (params) =>
    @_withCreateUpdateHandling(@_relation().update(@state.editedRecordID, params), 'update')

  delete: (pk) =>
    onlyRecordOnPage = @state.records.size() == 1

    @_relation().delete(pk)
      .then =>
        if onlyRecordOnPage
          @setState(page: 1, @loadRecords, errors: null)
        else
          @loadRecords()
      .catch BadRequestError, (error) =>
        @setState(errors: error.data)

  handleTableChange: =>
    @setState(page: 1, @loadRecords, errors: null)

  errors: ->
    <Alert bsStyle='danger'>{@state.errors.detail}</Alert> if @state.errors

  table: ->
    React.createElement(@tableComponent, @tableProps())

  tableProps: ->
    _.assign({}, @defaultTableProps(), @additionalTableProps())

  defaultTableProps: ->
    primaryKey: @_relation().model.primaryKey
    records:    @state.records.entityArray()
    onCreate:   @showCreateForm
    onUpdate:   @showUpdateForm
    onDelete:   @delete
    onChange:   @handleTableChange
    ref:        (component) => @_tableComponent = component

  pagination: ->
    pagination = @state.records.pagination

    if pagination
      <Pagination
       totalPages={pagination.pageCount}
       currentPage={pagination.pageNumber}
       onChange={@changePage} />

  form: ->
    switch @state.formAction
      when 'create'
        submit = @create
        record = null
      when 'update'
        submit = @update
        record = @state.records.find(@state.editedRecordID)

    React.createElement(@formComponent,
      action:        @state.formAction
      record:        record
      submit:        submit
      cancel:        @hideForm,
      backendErrors: @state.formErrors)

  render: ->
    <div>
      {@errors()}

      <Row>
        <Col xs={12}>
          {@table()}

          <div className='text-center'>
            {@pagination()}
          </div>
        </Col>
      </Row>

      {@form() if @state.showForm}
      {@additionalRender()}
    </div>

  afterCreate: (instance) ->
  afterUpdate: (instance) ->

  _relation: ->
    if _.isFunction(@relation) then @relation() else @relation

  _withCreateUpdateHandling: (promise, action) ->
    promise
      .then (instance) =>
        if action == 'create' then @afterCreate(instance) else @afterUpdate(instance)

        @hideForm()
        @loadRecords()
      .catch (error) =>
        fieldErrors = @_relation().model.attrsToFrontendNames(error.data)

        @setState(formErrors: fieldErrors)
